import React from 'react';
import { FileTextIcon, CpuIcon, FileCheck2Icon, ArrowRightIcon, ArrowDownIcon } from 'lucide-react';
import { promptAnatomy } from '../../data/samplePrompts';
const nodes = [{
  icon: FileTextIcon,
  label: 'PROMPT',
  sub: 'Your instruction',
  tone: 'bg-white text-plum border-gold/50',
  iconTone: 'bg-lilac-soft text-grape'
}, {
  icon: CpuIcon,
  label: 'AI',
  sub: 'ChatGPT · Claude · Gemini · DeepSeek',
  tone: 'bg-grape-deep text-white border-gold',
  iconTone: 'bg-gold text-plum'
}, {
  icon: FileCheck2Icon,
  label: 'RESULT',
  sub: 'Structured book development output',
  tone: 'bg-white text-plum border-grape/40',
  iconTone: 'bg-lilac text-grape-deep'
}];
export function PromptFlow() {
  return <>
      <div className="mx-auto mt-8 flex max-w-xs flex-col items-stretch gap-1.5" aria-label="What a prompt tells the AI" data-id="element-251" data-mp="34jbvo5w4bdmf">
        <p className="text-center text-xs font-bold uppercase tracking-wider text-plum/55" data-id="element-252" data-mp="157itzvydxk3d">A structured set of instructions that tells the AI:</p>
        {promptAnatomy.map((step, i) => <React.Fragment key={step} data-id="element-253" data-mp="1f0id25s744hm" data-mpi={i}>
            <span className="rounded-lg border border-gold/40 bg-white px-4 py-2 text-center text-sm font-black uppercase tracking-wide text-grape-deep" data-id="element-254" data-mp="1f1jowch1cv0e">
              {step}
            </span>
            {i < promptAnatomy.length - 1 && <ArrowDownIcon className="mx-auto h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-255" data-mp="10bcfem90ambu" />}
          </React.Fragment>)}
      </div>

      <div className="mt-10 flex flex-col items-stretch gap-3 sm:flex-row sm:items-center sm:justify-center" aria-label="How a prompt works" data-id="element-256" data-mp="1xy2pgddrxalc">
        {nodes.map((n, i) => <React.Fragment key={n.label} data-id="element-257" data-mp="1nzn6wystb9ng" data-mpi={i}>
            <div className={`flex items-center gap-3 rounded-2xl border px-4 py-3 sm:w-64 ${n.tone}`} data-id="element-258" data-mp="1o2hu2y37n8kk">
              <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${n.iconTone}`} data-id="element-259" data-mp="1k0w90pgivnza">
                <n.icon className="h-5 w-5" data-id="element-260" data-mp="8jo5e6dpabw6" />
              </span>
              <div className="min-w-0" data-id="element-261" data-mp="8i3d6neuz51h">
                <p className="font-display text-base font-black" data-id="element-262" data-mp="a0tsm8nlzepx">{n.label}</p>
                <p className="text-xs leading-snug opacity-75" data-id="element-263" data-mp="9yqybcffazfe">{n.sub}</p>
              </div>
            </div>
            {i < nodes.length - 1 && <ArrowRightIcon className="mx-auto h-5 w-5 rotate-90 text-gold-deep sm:mx-0 sm:rotate-0" aria-hidden="true" data-id="element-264" data-mp="1m6avywc9qo" />}
          </React.Fragment>)}
      </div>
    </>;
}